import React, { useContext, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import CompanyLogo from "../../CommonComponents/CompanyLogo";
import AlertContext from "../../../context/AlertContext";

export default function MobileView() {
  const Alert = useContext(AlertContext);

  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname === "/dp") Alert.navigate("/dp/instruction");
  }, [pathname, Alert]);

  return (
    <div className="dpMainContainer">
      <div className="dpHeader">
        <CompanyLogo />
      </div>
      <Outlet />
    </div>
  );
}
